import { createContext } from "react";
import { TargetsUploaderContextValues } from "../../../types";

export const TargetsUploaderContext = createContext<TargetsUploaderContextValues>({
    errorMessages: undefined,
    isUploading: false,
    wasProcessed: false,
    hasDataToChange: false,
    parsedTargetsData: [],
});
